import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import {
  render,
  MARK_LINK,
  NODE_PARAGRAPH,
} from 'storyblok-rich-text-react-renderer';
import { getPlainText } from '@storyofams/storyblok-toolkit';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';

export function ReferenceFaqItem({ blok }) {
  return (
    <div
      {...storyblokEditable(blok)}
      className="hidden"
      aria-hidden="true"
    />
  );
}

export default function ReferenceFaqSection({ blok }) {
  const items = Array.isArray(blok?.faq_items) ? blok.faq_items : [];

  if (!blok?.title && items.length === 0) {
    return null;
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem?.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          typeof faqItem?.answer === 'string'
            ? faqItem.answer
            : getPlainText(faqItem?.answer),
      },
    })),
  };

  return (
    <section
      {...storyblokEditable(blok)}
      className="pt-12 pb-16 lg:pt-20 lg:pb-24"
    >
      <Container>
        {blok?.title && (
          <FancyTitle
            text={blok.title}
            tag="h2"
            textAlign="text-left"
            marginBottom="mb-8"
          />
        )}

        {items.length > 0 && (
          <div className="divide-y divide-latori-gray">
            {items.map((faqItem, index) => {
              const key = faqItem?._uid || `${faqItem?.question || 'faq'}-${index}`;
              return (
                <details
                  key={key}
                  {...storyblokEditable(faqItem)}
                  open={index === 0}
                  className="py-5 group"
                >
                  <summary className="text-[16px] leading-[24px] font-bold cursor-pointer marker:text-latori-pink list-outside">
                    {faqItem?.question}
                  </summary>

                  {faqItem?.answer
                    && (typeof faqItem.answer === 'string' ? (
                      <p className="mt-3 text-[16px] leading-[24px]">
                        {faqItem.answer}
                      </p>
                    ) : (
                      render(faqItem.answer, {
                        markResolvers: {
                          [MARK_LINK]: LinkResolver,
                        },
                        nodeResolvers: {
                          [NODE_PARAGRAPH]: (children) => (
                            <p className="mt-3 text-[16px] leading-[24px]">
                              {children}
                            </p>
                          ),
                        },
                      })
                    ))}
                </details>
              );
            })}
          </div>
        )}
      </Container>

      {items.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      )}
    </section>
  );
}
